export phonenumber = (string, length) ->
  leading_0 = length != 8
  validation_length = if length == 8 then length else length - 1
  regex = "^#{if leading_0 then '0{1}' else ''}[0-9]{#{validation_length}}$"
  new RegExp(regex).test(string) || "Please enter a valid (#{length} digit) phone number"

export user_password = (string) ->
  string.length >= 6 || 'minimum_length_6'